import { render, staticRenderFns } from "./TestPassResultView.vue?vue&type=template&id=83e141be&"
import script from "./TestPassResultView.vue?vue&type=script&lang=ts&"
export * from "./TestPassResultView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports